// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"7c38715d","744":"359d1010","801":"6ba399e6"}[chunkId] + ".chunk.js";
};